export const option = {
  color: ['#F50A0A'],
  textStyle: { color: '#00eeff80' },
  legend: {
    top: 0,
    right: 0,
    data: [],
    itemWidth: 12,
    itemHeight: 12,
    textStyle: {
      color: '#00eeff',
      fontSize: 10
    }
  },
  tooltip: { trigger: 'axis', confine: true },
  grid: { left: '15%', top: '18%', bottom: '20%', right: '10%' },
  xAxis: {
    type: 'time',
    axisTick: { show: false },
    splitLine: { show: false },
    axisLine: { lineStyle: { color: '#fff', opacity: 0.4 } }
  },
  animation: true,
  yAxis: {
    type: 'value',
    axisTick: { show: false },
    splitLine: { lineStyle: { color: '#fff', opacity: 0.2 } },
    // axisLine: { lineStyle: { color: '#fff', opacity: 0.4 } },
    max(v) {
      return v.max < 100 ? 2 * v.max : v.max + 100;
    }
  },
  series: [
    {
      type: 'line',
      // name: '',
      symbol: 'circle',
      symbolSize: 4,
      smooth: true,
      data: [
        [100000, 100],
        [200000, 200]
      ]
    }
  ]
};

export const modeMap = {
  quick: 1,
  deep: 2,
  simple: 3,
  plus: 4
};
